import { useContext } from 'react';
import { RemoteConfigContext } from 'context/RemoteConfigContextProvider';

/**
 * Gets the RemoteConfigContext and returns it.
 */
export const useRemoteConfig = () => {
  const context = useContext(RemoteConfigContext);
  if (context === undefined) {
    throw new Error('useRemoteConfig is not within RemoteConfigContextProvider');
  }
  return context;
};

export default useRemoteConfig;
